import axios from '@/libs/api.request'

// ========== H5活动推送规则 ==========

export const getActivityPushRuleList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/activity/push-rules/page'
  })
}

export const addActivityPushRule = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/activity/push-rules/add'
  })
}

export const editActivityPushRule = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/activity/push-rules/edit'
  })
}

export const getActivityPushRuleDetail = (id) => {
  return axios.request({
    method: 'get',
    params: { id },
    url: '/activity/push-rules/detail'
  })
}

export const removeActivityPushRule = (id) => {
  return axios.request({
    method: 'delete',
    params: { id },
    url: '/activity/push-rules/remove'
  })
}

export const changeActivityPushRuleStatus = (id) => {
  return axios.request({
    method: 'put',
    params: { id },
    url: '/activity/push-rules/status'
  })
}

export const getActivityPushCrowds = (activityConfigId) => {
  return axios.request({
    method: 'get',
    params: { activityConfigId },
    url: '/activity/push-rules/crowds'
  })
}

export const getActivityConfigOptions = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/activity/config/option-list'
  })
}
